import type { PaymentType } from 'src/app/shared/utils/payments';

import { usePromoteFormState } from '../../../formContext/formState';
import { useConfirmHighAmount } from '../useConfirmHighAmount';
import { useConfirmPaymentMethodOverwrite } from '../useConfirmPaymentMethodOverwrite';

import { useCreateUserWrapper } from './hooks/useCreateUserWrapper';

export function usePrePaymentChecks(): (paymentType: PaymentType) => Promise<boolean> {
	const [, { clearLoading }] = usePromoteFormState();
	const confirmPaymentMethodOverwrite = useConfirmPaymentMethodOverwrite();
	const confirmHighAmount = useConfirmHighAmount();
	const createUser = useCreateUserWrapper();

	return async function prePaymentChecks(paymentType: PaymentType) {
		if (
			paymentType !== 'paypal' &&
			paymentType !== 'applePay' &&
			(!(await confirmHighAmount(paymentType)) || !(await confirmPaymentMethodOverwrite(paymentType)))
		) {
			clearLoading();
			return false;
		}

		if (!(await createUser(paymentType))) return false;

		return true;
	};
}
